import React, { useState, useEffect } from "react"
import hero1 from "../../images/careers/hero1.png"
import hero2 from "../../images/careers/hero2.png"
import hero3 from "../../images/careers/hero3.png"
import hero4 from "../../images/careers/hero4.png"
import hero3Mobile from "../../images/careers/hero3-mobile.png"
import hero4Mobile from "../../images/careers/hero4-mobile.png"

const CareersHero = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [visibleImages, setVisibleImages] = useState([])

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)")
    const setFlag = () => setIsMobile(mq.matches)
    setFlag()
    mq.addEventListener("change", setFlag)
    return () => mq.removeEventListener("change", setFlag)
  }, [])

  const imgs = isMobile
    ? [hero4Mobile, hero3Mobile]
    : [hero1, hero2, hero3, hero4]

  useEffect(() => {
    setVisibleImages(isMobile ? [0, 1] : [0, 1, 2, 3])
  }, [isMobile])

  return (
    <section className="hero has-background-dark hero-careers has-text-centered">
      <div className="hero-body">
        <div className="container">
          <h1 className="title is-size-1-desktop is-size-2-tablet is-size-4-mobile has-text-white mb-4 has-line-height-1">
            We’re drawn to passionate people who{" "}
            <br className="is-hidden-touch" />
            dream big, take risks, and lead.
          </h1>

          <p className="subtitle is-5 has-text-white-bis has-text-weight-light mb-5 mt-5">
            Our team brings energy, enthusiasm, creativity, and whole-hearted
            hustle into everything we do.
          </p>

          <div className="buttons is-centered mt-6">
            <a
              href="#open-roles"
              className="button is-link is-medium is-rounded px-6"
              onClick={e => {
                e.preventDefault()
                const el = document.getElementById("open-roles")
                if (el)
                  el.scrollIntoView({ behavior: "smooth", block: "start" })
              }}
            >
              Work with us
            </a>
          </div>
        </div>
      </div>

      <div className="hero-images">
        {imgs.map((src, i) => (
          <figure
            key={i}
            className={`image-tile ${
              isMobile ? `mobile-${i + 1}` : `tile-${i + 1}`
            } ${visibleImages.includes(i) ? "animate-in" : "animate-out"}`}
          >
            <img
              src={src}
              alt={`InPowered team ${i + 1}`}
              loading="eager"
              decoding="async"
            />
          </figure>
        ))}
      </div>
    </section>
  )
}

export default CareersHero
